import React, { useEffect, useCallback, useState, useRef } from "react";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { ActionCell } from "./GridCells";
import { Box, Typography } from "@mui/material";

const LoadingBlock = ({ getRows, pageSize, startRow, onLoaded }) => {
  const [rows, setRows] = useState();

  useEffect(() => {
    let cleaningUp;
    getRows(pageSize, startRow).then((rows) => {
      if (cleaningUp) return;
       console.log(rows,"rows")
      setRows(rows);
    });
    return () => {
      cleaningUp = true;
    };
  }, [getRows, pageSize, startRow]);

  useEffect(() => {
    if (!rows) {
      return;
    }
    onLoaded(rows, startRow);
  }, [onLoaded, rows, startRow]);

  return null;
};

function ControlledTable({
  rows,
  totalCount,
  getRows,
  onChange,
  onApiAvailable,
  onPageNumberChange,
  pagination,
  pageSize,
  pageNumber,
  components,
  columnDefs,
  getRowNodeId,
  hasActionButtons,
  refreshCounter,
  // height = "500px",
}) {
  const [gridApi, setGridApi] = useState();
  const gridRef = useRef();
  const [loadingBlocks, setLoadingBlocks] = useState([]);
  let paginationProps = {};


  const getPlaceholderItems = (startRow, length) => {
    const items = [];
    for (let index = startRow; index < length; index += 1) {
      items.push({ index, placeholder: true });
    }
    return items;
  };

  const isPlaceholder = useCallback(
    (i) => !rows[i] || rows[i].placeholder,
    [rows]
  );

  const needsLoading = useCallback(
   
    [rows, pageSize, isPlaceholder]
  );

 
  useEffect(() => {
    if (!gridApi || isNaN(pageNumber)) {
      return;
    }
    const currentPage = gridApi.paginationGetCurrentPage();
    if (pageNumber === currentPage) {
      return;
    }
    gridApi.paginationGoToPage(pageNumber);
  }, [gridApi, pageNumber]);

  const onGridReady = useCallback(
    
  );

  const onLoaded =()=>{}

  const onPaginationChanged = useCallback(
    ({ newPage }) => {
      if (!gridApi || !newPage) {
        return;
      }
      const currentPage = gridApi.paginationGetCurrentPage();
      if (onPageNumberChange) {
        onPageNumberChange(currentPage);
      }
    },
    [gridApi, onPageNumberChange]
  );

  useEffect(() => {
    if (!gridApi) {
      return;
    }
    if (loadingBlocks.includes(pageNumber * pageSize)) {
      gridApi.showLoadingOverlay();
    } else {
      gridApi.hideOverlay();
    }
  }, [gridApi, pageNumber, pageSize, loadingBlocks]);

  useEffect(() => {
    const startRow = pageNumber * pageSize;
    if (!loadingBlocks.includes(startRow) ) {
      // We haven't started loading the block yet. Start loading it
      setLoadingBlocks([...loadingBlocks, startRow]);
    }
  }, [loadingBlocks, pageNumber, pageSize]);

  const onRowClick = (params) => {};
  const rowHeight = 38;

  return totalCount === -1 ? (
    <NoData />
  ) : (
    <div
      aria-live="polite"
      aria-busy={loadingBlocks.includes(pageNumber * pageSize)}
      className="ag-theme-material"
      // style={{ height }}
     style={{ height: "470px",padding:"10px" }}
    >
      <AgGridReact
        ref={gridRef}
        columnDefs={columnDefs}
        components={components}
        rowData={rows}
        rowCount={totalCount}
        serverSideInfiniteScroll={true}
        rowModelType="clientSide"
        onPaginationChanged={onPaginationChanged}
        getRowId={getRowNodeId}
        onGridReady={onGridReady}
        {...paginationProps}
        onRowClicked={onRowClick}
        defaultColDef={{
          flex: 1,
          minWidth: 100,
        }}
        domLayout="autoHeight"
        headerHeight="38"
        rowHeight={rowHeight}
      />
      {loadingBlocks.map((startRow) => (
        <LoadingBlock
          key={`loadingBlock:${startRow}`}
          getRows={getRows}
          startRow={startRow}
          pageSize={pageSize}
          onLoaded={onLoaded}
          refreshCounter={refreshCounter}
        />
      ))}
    </div>
  );
}

export default ControlledTable;

function NoData() {
  return (
    <Box
      p={2}
      mt={1}
      borderRadius={2}
      border="1px solid #0099CC"
      sx={{ backgroundColor: "#33b5e523" }}
    >
      <Typography color="#0099CC">No Data To Show</Typography>
    </Box>
  );
}
